import { formatCompactInr } from "@/lib/formatCompactInr";

/**
 * Format numeric or currency value for order KPIs. One function per file (single method per file).
 */
export function fmtVal(v: number, f: "currency" | "number"): string {
  if (f !== "currency") return v.toLocaleString();
  return formatCompactInr(v);
}
